var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#00004f","strokeWidth":"2","d":"M1.334 1h21.333M1.334 1v16h21.333V1M1.334 1 12 9.889 22.667 1"}));
}

Mail.defaultProps = {"width":"24","height":"18","fill":"none","viewBox":"0 0 24 18"};

module.exports = Mail;

Mail.default = Mail;
